// copyTextToClipboard.js
import { resourceLog } from './debug.js';

const legacyCopyTextToClipboard = text => {
  return new Promise((resolve, reject) => {
    const isRTL = document.documentElement.getAttribute('dir') == 'rtl';
    const textArea = document.createElement('textarea');

    // Prevent zooming on iOS
    textArea.style.fontSize = '12pt';
    // Reset box model
    textArea.style.border = '0';
    textArea.style.padding = '0';
    textArea.style.margin = '0';
    // Move element out of screen horizontally
    textArea.style.position = 'absolute';
    textArea.style[isRTL ? 'right' : 'left'] = '-9999px';
    // Move element to the same position vertically
    const yPosition = window.pageYOffset || document.documentElement.scrollTop;
    textArea.style.top = `${yPosition}px`;
    // prevent modile virtual keyboard show up
    textArea.setAttribute('readonly', '');
    textArea.value = text;

    document.body.appendChild(textArea);

    setTimeout(() => {
      try {
        textArea.select();
        textArea.setSelectionRange(0, textArea.value.length);
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        successful ? resolve('successful') : reject();
        resourceLog('Fallback: Copying text command was ' + msg);
      } catch (err) {
        reject(err);
      } finally {
        document.body.removeChild(textArea);
      }
    });
  });
};

const copyTextToClipboard = async text => {
  let legacyResult;

  try {
    legacyResult = await legacyCopyTextToClipboard(text);
  } catch (e) {
    resourceLog('Legacy Copying text command failed ' + e);
  }

  if (legacyResult === 'successful') {
    return legacyResult;
  } else {
    try {
      /**
       * android webview on navigator.clipboard.writeText
       * will cause "DOMException: write Permission denied"
       * so try catch it
       */
      return await navigator.clipboard.writeText(text);
    } catch (e) {
      throw new Error(e);
    }
  }
};

export default copyTextToClipboard;
